import React from 'react'; 
import { HashRouter as Router } from 'react-router-dom';
import AppLayout from './component/AppLayout';

import './assets/css/meyawo.css';
import './App.css';
import './assets/css/darkMode.css';
import './assets/css/pricing.css';
import './index.css';
import './assets/css/loading.css';
import './assets/css/loader.css';
import './assets/css/projects.css';
import './assets/css/service.css';

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;